import {Component, Input, OnInit} from '@angular/core';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {EndUserNumber} from '../../../../gt-api/index';
import {GtNotificationService} from '../../../services/gt-notification.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'gt-twinning-settings',
  templateUrl: './twinning-settings.component.html',
  styleUrls: ['./twinning-settings.component.scss']
})
export class TwinningSettingsComponent implements OnInit {
  @Input() login: string;
  @Input() oname: string;
  @Input() canEdit = true;

  euNumbers: EndUserNumber[];

  constructor(
    private directoryService: GtDirectoryService,
    private authenticationService: GtAuthenticationService,
    private translateService: TranslateService,
    private notificationService: GtNotificationService
  ) {
    this.login = this.login ? this.login : this.authenticationService.login;
    this.oname = this.oname ? this.oname : this.authenticationService.oname;
  }

  ngOnInit(): void {
    this.directoryService.getEndUserNumbers(this.oname, this.login).subscribe(euNumbers => {
      this.euNumbers = euNumbers;
    });
  }

  toggleNumber(euNumber: EndUserNumber, checked: boolean) {
    euNumber.enabled = checked;
    this.directoryService.editEndUserNumber(this.oname, this.login, euNumber).subscribe(
      () => {
        console.log('twinning settings changed');
      },
      () => this.notificationService.errorNotification.next(this.translateService.instant('twinning.error'))
    );
  }
}
